<template>
    <div>
        <h3 class="text-2xl font-bold text-center mb-4">Add new Trial Link</h3>
        <form>
            <div class="grid grid-cols-1 gap-4">
                <div class="mx-auto">
                    <MazInput 
                        v-model="trialLinkName" 
                        :label="$t('trial_links.name')"
                    />
                </div>
                
            </div>
            <div class="text-center mt-5">
                <button type="submit" @click="submitTrialLink()" class="bg-button text-buttonText dark:bg-growth dark:text-black ml-5 rounded-lg p-2 px-3 -mt-1 cursor-pointer">{{ $t('save') }}</button>
            </div>
            
        </form>
    </div>
</template>
<script>
export default {
    props: ['modelID','companyID'],
    data() {
        return {
            trialLinkName: '',
        };
    },
    methods: {
        submitTrialLink() {
            alert('This feature is not yet implemented');
            throw new Error('adding new trial link feature is not yet implemented');
        },
    },
    mounted() {
        // Code to run when the component is mounted goes here
    },
};
</script>